import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { getCookie } from "../../utils/cookies";
import { acceptCookies } from "../../utils/datalayer.mapping";
import { processVideoIframeUrl } from "./video";
export const VideoComponent = (param)=>{
    let { video, showAcceptCookiesButton } = param;
    if (!video.Url) return /*#__PURE__*/ _jsx(_Fragment, {});
    switch(video.Kind){
        case 'youtube':
            return /*#__PURE__*/ _jsx(VideoIframe, {
                video,
                showAcceptCookiesButton
            });
        case 'vimeo':
            return /*#__PURE__*/ _jsx(VideoIframe, {
                video,
                showAcceptCookiesButton
            });
        case 'html5':
            throw new Error("HTML5 videos are not (yet) supported") // But this would return something other than an iframe
            ;
        default:
            throw new Error(`The video type ${video.Kind} is not (yet) supported`);
    }
};
const VideoIframe = (param)=>{
    let { video, showAcceptCookiesButton = true } = param;
    const areVideoCookiesAccepted = getCookie("video-cookies") === "yes";
    if (!areVideoCookiesAccepted) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "video-cookie-wrapper",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--s text--styled",
                    children: "Om deze video te bekijken, moet je video-cookies accepteren."
                }),
                showAcceptCookiesButton && /*#__PURE__*/ _jsx("button", {
                    onClick: ()=>{
                        acceptCookies();
                        window.location.reload();
                    },
                    className: "button button--primary",
                    children: "Accepteer cookies"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("iframe", {
        className: "block__iframe video-cookie-wrapper iframe",
        src: processVideoIframeUrl(video),
        title: `Video: ${video.VideoName}`,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true,
        referrerPolicy: "strict-origin-when-cross-origin"
    }, "iframe");
};
